import { combineReducers } from "redux";
import authReducer from "./authReducer";
import i18nReducer from "./i18nReducer";
import usersReducer from "./usersReducer";
import devicesReducer from "./devicesReducer";
import servicesReducer from "./servicesReducer";
import dashboardReducer from "./dashboardReducer";
import contractsReducer from "./contractsReducer";
import integrationReducer from "./integrationReducer";
import installationReducer from "./installationReducer";
import organizationsReducer from "./organizationsReducer";
import CounterDashboardReducer from "./CounterDashboardReducer";
import ServiceOrdersReducer from "./ServiceOrdersReducer";
import monitoringsReducer from "./monitoringReducer";
export default combineReducers({
  authReducer,
  i18nReducer,
  usersReducer,
  devicesReducer,
  servicesReducer,
  dashboardReducer,
  contractsReducer,
  integrationReducer,
  installationReducer,
  organizationsReducer,
  CounterDashboardReducer,
  ServiceOrdersReducer,
  monitoringsReducer,
});
